export const BODY_THEME_YELLOW_BENSON_AND_HEDGES = (props) => {

	let svgWidth = props.svgWidth || "100%";
	let svgHeight = props.svgHeight || "100%";
	let svgViewBox = props.svgViewBox || "0 0 720 504";
	let svgPreserveAspectRatio = props.svgPreserveAspectRatio || "none";
	let svgStyle = props.svgStyle || {background:"transparent"};


	return(
		<div>
		<svg xmlns="http://www.w3.org/2000/svg"
			width={svgWidth}
			height={svgHeight}
			viewBox={svgViewBox}
			preserveAspectRatio={svgPreserveAspectRatio}
			style={svgStyle}
		>

        
      


    {/*Two*/}
    <polygon 
        fill="rgb(90,90,90)" 
        points="60.552,329.4 92.127,396 655.779,396 655.779,275.4 642.933,250.745 608.1,230.634 436.5,209.563 86.8,185.109 76.176,203.256 76.193,275.4 60.568,275.4 60.552,329.4"
    />
    {/*One*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M86.8,185.109l349.7,24.454l171.6,21.07l34.833,20.111v15.957 H612.34c-15.189-20.885-39.639-34.682-67.349-35.165c-23.848-0.417-45.626,9.108-61.376,24.737 c-26.417-13.027-57.538-16.255-83.05-17.921l-147.315-9.01c-18.387-1.125-5.965,30.828-22.414,18.791 c-13.847-10.339-30.925-16.596-49.456-16.92c-32.641-0.569-61.421,17.41-76.258,44.186H76.176v-72.144L86.8,185.109L86.8,185.109z"
    />
    {/*Three*/}
    <polygon 
        fill="rgb(0,0,0)" 
        points="92.127,396 642.933,396 642.933,298.921 227.025,275.4 60.568,275.4 60.552,329.4 92.127,396"
    />
    {/*Rear Bumper*/}
    <polygon 
        fill="rgb(0,0,0)" 
        points="76.176,329.4 92.127,396 179.855,396 179.855,329.4 76.176,329.4"
    />
    {/*Rear Bumper Highlight*/}
    <polygon 
        fill="rgb(0,0,0)" 
        points="76.176,285.279 60.552,285.279 60.568,275.4 76.176,275.4 76.176,285.279"
    />
    {/*Rear Bumper Shadow*/}
    <polygon 
        fill="rgb(90,90,90)" 
        points="60.552,329.4 76.176,329.4 92.127,396 60.552,329.4"
    />
    {/*Rocker*/}
    <path 
        fill="rgb(110,110,110)" 
        d="M642.933,379.3V396H92.127l-0.001-0.002L92.127,396l0,0l-4-16.7 C283.727,379.3,447.309,379.3,642.933,379.3L642.933,379.3z"
    />
    {/*Inset Highlight*/}
    <path 
        fill="rgb(50,50,50)" 
        d="M459.484,351.795c-4.402-10.491-8.731-21.947-22.984-22.57	L179.855,318.02v41.717l280.313-0.024C461.342,359.712,461.205,355.898,459.484,351.795L459.484,351.795z"
    />
    {/*Inset Shadow*/}
    <path 
        fill="rgb(90,90,90)" 
        d="M459.484,351.795c-4.402-10.491-8.731-21.947-22.984-22.57	L179.855,318.02v12.312l251.604,10.985c10.855,0.475,22.532,9.438,26.881,16.582c0.765,1.256,1.308,1.813,1.828,1.813 C461.342,359.712,461.205,355.898,459.484,351.795L459.484,351.795z"
    />  
    {/*Door Handle Highlight*/}
    <path 
        fill="rgb(110,110,110)" 
        d="M302.899,232.38c-0.903-1.849-2.974-4.587-8.14-6.69 c-9.912-4.039-26.723-4.895-28.843-5.051c-2.937-0.219-9.122-0.149-8.186,5.914l0.478,3.094L302.899,232.38L302.899,232.38z"
    />
    {/*Door Handle Shadow*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M266.162,231.082c1.954,0,3.548,1.594,3.548,3.548	s-1.594,3.548-3.548,3.548c-1.953,0-3.547-1.594-3.547-3.548S264.209,231.082,266.162,231.082L266.162,231.082z M300.152,232.212 l-29.457-1.802c0.471,5.016,2.687,6.109,4.926,6.132l20.105,1.186C300.893,237.779,300.152,232.212,300.152,232.212 L300.152,232.212z"
    />
    {/*One Highlight*/}
    <polygon 
        fill="rgb(110,110,110)" 
        points="436.5,209.563 86.8,185.109 76.176,203.256 77.452,203.257 436.5,209.563"
    />


{/*"Top Color Yellow"*/}
 
    
    {/*Two*/}
    <polygon 
        fill="rgb(255,242,0)" 
        points="369.117,396 655.779,396 655.779,275.4 642.933,250.744 608.099,230.634 436.5,209.563 369.117,204.852 369.117,396 	"
    />
    {/*Three*/}
    <polygon 
        fill="rgb(255,203,5)" 
        points="369.117,396 642.933,396 642.933,298.921 369.117,283.436 369.117,396 	"
    />
    {/*One*/}
    <path 
        fill="rgb(255,212,0)" 
        d="M227.025,194.916L436.5,209.563l171.599,21.07l34.834,20.11 v15.958h-30.592c-15.19-20.885-39.64-34.682-67.35-35.165c-23.848-0.417-45.626,9.109-61.377,24.737 c-26.416-13.027-57.537-16.255-83.049-17.921l-147.315-9.01c-18.387-1.125-5.965,30.828-22.414,18.791 c-1.244-0.929-2.516-1.824-3.811-2.686V194.916L227.025,194.916z"
    />
    {/*One Front Bumper*/}   
    <polygon 
        fill="rgb(255,230,0)" 
        points="655.779,275.399 642.933,250.744 608.099,230.634 642.933,285.278 642.933,298.921 655.779,298.921 655.779,275.399 	"
    />
    {/*Three Front Bumper*/}
    <polygon 
        fill="rgb(255,212,0)" 
        points="655.779,379.3 655.779,298.921 642.933,298.921 642.933,379.3 655.779,379.3 	"
    />
    {/*Vent Background*/}
    <path 
        fill="rgb(255,245,0)" 
        d="M629.269,348.577l18.681,4.628l2.489-0.004 c1.779-0.004,3.422-0.325,3.422-2.821l-0.001-29.823c0-1.021-0.404-1.261-0.984-1.281l-21.414-0.759 c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603C625.877,344.809,626.697,347.94,629.269,348.577L629.269,348.577z"
    />
    {/*Vent*/}
    <path 
        fill="rgb(250,175,25)" 
        d="M648.527,353.204l-9.437-5.126c-1.72-0.934-2.519-2.618-2.52-4.77 l-0.005-11.837c0-2.773,0.814-4.013,2.066-4.716l13.386-7.511l-20.558-0.729c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603 c0,2.714,0.82,5.846,3.392,6.482l18.681,4.628L648.527,353.204L648.527,353.204z"
    />
    {/*Vent Shadow*/}
    <path 
        fill="rgb(245,115,35)" 
        d="M628.042,324.644c-0.001-2.038,1.858-2.907,3.285-3.068 l20.691-2.33l-20.558-0.729c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603c0,2.714,0.82,5.846,3.392,6.482 c-0.957-1.553-1.22-4.483-1.221-5.71L628.042,324.644L628.042,324.644z"
    />
    {/*Vent Highlight*/}
    <path 
        fill="rgb(255,245,0)" 
        d="M632.043,348.424l12.192,3.385l-7.12-4.247 c-6.029-3.596-8.149-15.236-8.107-8.605C629.051,345.587,629.347,347.676,632.043,348.424L632.043,348.424z"
    />
    {/*Front Lip Highlight*/}
    <polygon 
        fill="rgb(255,245,0)" 
        points="543.528,365.473 655.779,365.473 655.779,364.026 642.933,362.38 633.41,364.026 543.528,364.026 543.528,365.473 	"
    />
    {/*Rocker*/}
    <path 
        fill="rgb(255,242,0)" 
        d="M642.933,379.3V396H369.117v-16.7	C369.117,379.3,546.427,379.3,642.933,379.3L642.933,379.3z"
    />
    {/*Rocker Front*/}
    <polygon 
        fill="rgb(255,230,0)" 
        points="642.933,379.3 642.933,396 655.779,396 655.779,379.3 642.933,379.3 	"
    />
    {/*Inset*/}
    <path 
        fill="rgb(255,242,0)" 
        d="M459.483,351.795c-4.401-10.491-8.73-21.947-22.983-22.57 l-67.383-2.941v33.429h91.052C461.342,359.712,461.205,355.898,459.483,351.795L459.483,351.795z"
    />
    {/*Inset Shadow*/}
    <path 
        fill="rgb(245,130,32)" 
        d="M459.483,351.795c-4.401-10.491-8.73-21.947-22.983-22.57 l-67.383-2.941v12.312l62.343,2.722c10.855,0.474,22.532,9.438,26.881,16.582c0.764,1.256,1.308,1.813,1.828,1.813 C461.342,359.712,461.206,355.898,459.483,351.795L459.483,351.795z"
    />
    {/*One Hightlight*/}
    <polygon 
        fill="rgb(255,242,0)" 
        points="436.5,209.563 227.025,194.916 227.025,205.884 436.5,209.563 	"
    />


{/*"Mirror"*/}

    {/*Mirror Body Shadow*/}
    <path 
        fill="rgb(255,203,5)" 
        d="M420.018,215.521l1.227,1.87 c-8.865-0.307-14.482,2.165-16.687,3.683c-2.327,1.602-2.546,5.234,3.085,4.68l25.139-2.47c1.26,0.041,2.572-0.003,3.807-0.202 c1.378-0.223,4.542-1.097,3.238-3.086l-2.383-3.635c-1.073,0.17-2.324,0.216-3.747,0.117 C429.137,216.16,424.577,215.84,420.018,215.521L420.018,215.521z"
    />
    {/*Mirror Background*/}
    <path 
        fill="rgb(255,221,0)" 
        d="M437.443,216.361c4.697-0.74,6.028-3.823,3.786-7.244l-3.907-5.96 c-0.822-1.253-3.626-4.647-5.669-6.215c-6.813-5.228-12.349-6.552-21.103-6.552c-4.264,0-5.566,0.952-7.2,4.458 c-0.749,1.604-1.124,3.95-1.124,5.72v5.09c0,1.447,0.091,3.408,1.29,4.729l2.525,2.78c0.802,0.882,2.007,1.519,3.195,1.601 l10.78,0.754L423.61,221c0.935,1.426,3.336,1.578,4.617,1.802c2.035,0.354,5.423,0.755,8.36,0.28	c1.378-0.223,4.542-1.097,3.238-3.086L437.443,216.361L437.443,216.361z"
    />
    {/*Mirror Base*/}
    <path 
        fill="rgb(253,185,19)" 
        d="M437.443,216.361c-1.073,0.17-2.324,0.217-3.747,0.117	l-13.679-0.957L423.61,221c0.935,1.426,3.336,1.578,4.617,1.802c2.035,0.354,5.423,0.755,8.36,0.28	c1.378-0.223,4.542-1.097,3.238-3.086L437.443,216.361L437.443,216.361z"
    />
    {/*Mirror_Base_Highlight*/}
    <path 
        fill="rgb(255,203,5)" 
        d="M438.299,219.592l-1.062-1.619
		c-0.336-0.513-1.093-0.805-1.733-0.85l-14.267-0.997l0.845,1.288l7.073,0.523c2.369,0.174,3.686,0.219,5.114,2.258
		c0.733,1.045,2.132,1.713,3.148,1.344C438.434,221.169,438.88,220.408,438.299,219.592L438.299,219.592z"
    />
    {/*"Mirror_Shadow"*/}
    <path 
        fill="rgb(253,185,19)" 
        d="M437.443,216.361c-1.073,0.17-2.324,0.217-3.747,0.117	l-24.459-1.711c-1.188-0.082-2.394-0.719-3.195-1.601l-2.525-2.78c-0.374-0.412-0.64-0.886-0.829-1.388	c6.532,0.457,33.813,2.364,38.542,0.118C443.472,212.538,442.141,215.621,437.443,216.361L437.443,216.361z"
    />
    {/*"Mirror_Highlight"*/}
    <path 
        fill="rgb(255,245,0)" 
        d="M402.947,203.555c10.225,2.229,20.418-6.53,32.119-2.197 c-1.167-1.412-2.479-2.742-3.855-3.847c-3.146-2.373-6.389-4.21-10.196-5.287c-3.183-0.815-6.384-1.06-9.66-1.109	c-3.919-0.018-5.603,0.411-7.351,4.036c-0.744,1.691-1.035,3.584-1.057,5.423V203.555L402.947,203.555z"
    />
    
    

{/*"Bee Logo"*/}
 
    {/*Black Background*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M160.084,239.631l-26.625-51.259l147.058,10.283l30.41,7.931 c-1.82-2.049-3.635-4.103-5.418-6.184l21.363,1.494c0.398,0.376,0.77,0.785,1.108,1.208c19.491,3.433,38.584,8.304,53.974,21.577 c42.008,6.182,74.432,42.522,74.432,86.2c0,21.191-7.158,41.482-21.092,57.641l51.765,10.816l-72.361,6.196 c-8.207,4.979-17.104,8.466-26.372,10.465h-37.28c-38.343-8.527-68.923-43.229-68.923-85.118c0-15.729,4.203-30.507,11.545-43.268
		C276.439,275.137,198.344,313.292,160.084,239.631L160.084,239.631z M341.803,228.197c6.963-2.322,14.313-3.784,21.923-4.266 c-8.267-6.603-27.014-9.541-36.396-11.192c-0.062,0.06-0.124,0.118-0.187,0.176C333.209,216.941,338.738,222.689,341.803,228.197 L341.803,228.197z"
    />
    {/*Black Inset*/}
    <path 
        fill="rgb(65,65,65)" 
        d="M452.372,337.703c-3.475-4.719-8.257-8.146-15.872-8.479 l-153.58-6.705c1.884,13.675,7.034,26.316,14.557,37.192h144.485C446.489,352.857,449.967,345.458,452.372,337.703L452.372,337.703
		z"
    />
    {/*Black Shadow*/}
    <path 
        fill="rgb(50,50,50)" 
        d="M452.372,337.703c-3.475-4.719-8.257-8.146-15.872-8.479 l-153.58-6.705c0.585,4.25,1.488,8.399,2.678,12.429l145.862,6.368c5.867,0.257,11.975,2.994,17.035,6.582 C450.002,344.583,451.294,341.178,452.372,337.703L452.372,337.703z"
    />
    {/*Bee*/}
    <path 
        fill="rgb(255,212,0)" 
        d="M374.207,249.321c7.555-8.856,19.398-7.813,24.377-6.872 c6.002,1.133,11.658,3.65,16.448,7.439c-5.762-0.02-10.015,1.954-12.989,4.562c-8.573-3.407-16.405-8.718-18.185-10.108 c0.731,7.926,5.726,14.786,11.449,20.007c-5.038,0.317-12.809-3.967-15.655-6.008c3.09,9.713,9.867,15.248,17.366,21.339 c-4.461-0.977-13.477-4.629-16.487-6.56c7.562,13.554,24.057,22.05,38.525,25.752c5.951,1.522,15.66,2.073,19.874-3.454
		c0.55,2.289,0.949,4.695,0.396,6.968c-1.046,4.272-7.855,5.195-11.438,5.653c3.167,2.675,7.768,3.021,11.729,2.589 c-0.753,7.101-1.143,16.245-4.327,23.11c-0.215,0.331-0.815,0.42-1.188,0.292c-5.097-1.751-9.913-5.644-12.956-10.116l5.313-5.795 c-1.256-1.151-7.182-5.575-8.368-6.525c0.954-0.385,1.787-1.02,2.412-1.837c0-0.982-0.036-4.839-0.379-6.74 c-7.036,1.114-14.111,1.576-21.231,1.58l-0.385,0.88C380.421,292.892,368.904,271.648,374.207,249.321L374.207,249.321z M409.731,323.327c1.541,2.351,5.13,5.216,8.315,5.668c-2.872-4.479-6.398-10.865-6.522-16.354c1.922-1.521,4.44-2.929,6.646-3.995 c-0.069-0.802-0.018-1.954-0.026-2.613c-4.945,0.454-11.782,1.194-16.813,1.218c0.029,10.79,2.872,21.607,10.877,29.189 C410.309,330.627,409.549,325.289,409.731,323.327L409.731,323.327z M383.565,311.377c-1.253-1.435-4.523-4.896-2.516-6.898 c1.682-1.677,4.309,0.941,5.311,2.108l0.142-0.149c-4.632-6.958-11.722-13.046-18.293-18.088c-0.849-0.651-2.23-1.761-3.128-0.684 s0.18,2.751,0.801,3.612c4.695,6.514,10.999,15.606,17.501,20.354L383.565,311.377L383.565,311.377z M374.326,318.643 c-1.143-1.303-3.434-4.665-1.662-6.128c1.771-1.464,3.862,0.676,4.904,1.811l0.255-0.132c-3.643-7.026-12.259-13.533-18.329-18.238 c-0.676-0.524-2.26-1.845-3.125-0.916c-0.866,0.929-0.221,2.446,0.49,3.447c4.408,6.218,11.03,15.935,17.248,20.333 L374.326,318.643L374.326,318.643z M365.148,325.54c-1.04-1.233-2.618-4.058-1.078-5.382c1.539-1.325,2.85,0.15,4.079,0.865 l0.32-0.235c-4.177-6.625-13.511-14.55-19.187-18.813c-0.693-0.521-1.9-0.918-2.583-0.187c-0.683,0.732,0.165,2.392,0.591,3.006 c4.979,7.183,10.904,15.072,17.488,20.855L365.148,325.54L365.148,325.54z M339.477,319.13c-2.713,3.92-20.314,12.4-24.669,14.07 c1.038,1.251,6.425,1.851,8.108,2.139c-3.107,2.8-16.824,7.29-19.912,8.274c2.222,4.931,5.027,9.572,8.356,13.833 c15.171-6.599,29.91-15.435,42.598-26.043c-3.052,8.644-10.297,17.51-16.568,23.896c3.111,0.128,6.223-1.03,8.267-1.797 c-2.396,6.255-13.427,15.433-18.104,19.232l-0.415,0.337c4.342,3.318,9.182,5.817,14.344,7.438 c8.193-5.338,23.02-28.313,27.46-37.05c-0.425,9.336-4.456,21.576-5.985,25.51l6.825-4.264c-0.679,3.189-5.498,14.218-8.819,19.981	c5.07,0.899,11.118,1.565,16.259,1.476c4.698-8.486,8.247-17.561,10.555-26.982c2.275,4.115,0.844,13.822,0.378,18.29 c1.554-0.848,2.334-2.871,3.571-4.133c0.627,3.912-0.446,7.918-1.116,11.76c3.098,0.038,6.403-0.671,9.366-1.599l3.285-17.992	c-16.681-10.249-31.274-22.154-44.376-36.571c-10.742-11.82-25.107-15.513-39.54-20.075c-10.94-3.459-18.52-13.248-18.677-24.795 l-0.094-0.132c-7.445,11.016-7.623,26.713-4.757,39.202C309.6,324.08,324.732,322.95,339.477,319.13L339.477,319.13z M314.283,297.953c-10.299-9.203-4.639-28.552,3.826-36.813c7.455,0.4,18.648,4.752,28.628,9.454 c-1.38-3.693-11.292-11.134-17.458-14.844c10.015-1.531,20.137,2.266,25.313,5.137c-0.515-4.183-3.236-10.289-5.565-14.112 c11.229,1.173,19.94,14.386,20.934,23.349c0.405,3.649,0.923,7.296,0.812,10.969l-13.525-6.907l4.545,16.701l-15.904-9.533 l5.174,16.755l-16.367-7.235l4.381,14.002C330.629,306.091,320.666,303.655,314.283,297.953L314.283,297.953z"
    />
    {/*Bee Highlight*/}
    <path 
        fill="rgb(255,242,0)" 
        d="M374.207,249.321c7.555-8.856,19.398-7.813,24.377-6.872 c6.002,1.133,11.658,3.65,16.448,7.439c-5.762-0.02-10.015,1.954-12.989,4.562c-8.573-3.407-16.405-8.718-18.185-10.108 c0.731,7.926,5.726,14.786,11.449,20.007c-5.038,0.317-12.809-3.967-15.655-6.008c3.09,9.713,9.867,15.248,17.366,21.339 c-4.461-0.977-13.477-4.629-16.487-6.56c2.431,4.356,5.785,8.188,9.697,11.51l-11.167-0.632	C373.475,273.615,371.283,261.634,374.207,249.321L374.207,249.321z M309.031,280.038c1.035-7.308,4.676-14.602,9.078-18.898 c7.455,0.4,18.648,4.752,28.628,9.454c-1.38-3.693-11.292-11.134-17.458-14.844c10.015-1.531,20.137,2.266,25.313,5.137 c-0.515-4.183-3.236-10.289-5.565-14.112c11.229,1.173,19.94,14.386,20.934,23.349c0.405,3.649,0.923,7.296,0.812,10.969 l-13.525-6.907l2.371,8.714l-12.313-0.696l-1.418-0.85l0.242,0.783L309.031,280.038L309.031,280.038z M436.931,329.249 c-0.143-0.008-0.285-0.018-0.431-0.024l-11.128-0.485c2.573,2.331,5.6,4.216,8.731,5.291c0.373,0.128,0.974,0.039,1.188-0.292
		C435.947,332.326,436.485,330.817,436.931,329.249L436.931,329.249z M417.67,328.403l-1.893-0.083 c0.758,0.332,1.524,0.569,2.27,0.675C417.922,328.801,417.797,328.604,417.67,328.403L417.67,328.403z M410.127,328.073 l-4.297-0.188c1.609,3.132,3.705,6.023,6.378,8.555C411.207,333.378,410.524,330.448,410.127,328.073L410.127,328.073z M355.629,325.694l-23.652-1.033c-6.252,3.651-14.396,7.476-17.169,8.539c1.038,1.251,6.425,1.851,8.108,2.139	c-3.107,2.8-16.824,7.29-19.912,8.274c2.222,4.931,5.027,9.572,8.356,13.833c15.171-6.599,29.91-15.435,42.598-26.043 c-3.052,8.644-10.297,17.51-16.568,23.896c3.111,0.128,6.223-1.03,8.267-1.797c-0.721,1.881-2.222,4.025-4.096,6.209h17.504 c4.287-6.355,8.004-12.567,9.876-16.251c-0.235,5.161-1.571,11.209-2.979,16.251h21.682c0.044-0.177,0.088-0.354,0.131-0.53 c0.093,0.168,0.179,0.345,0.26,0.53h6.279c-13.023-8.893-24.726-18.995-35.431-30.775 C357.832,327.78,356.746,326.703,355.629,325.694L355.629,325.694z"
    />
    {/*Bee Shadow*/}
    <path 
        fill="rgb(245,130,32)" 
        d="M436.931,329.249c-0.143-0.008-0.285-0.018-0.431-0.024 l-11.128-0.485c2.573,2.331,5.6,4.216,8.731,5.291c0.373,0.128,0.974,0.039,1.188-0.292
		C435.947,332.326,436.485,330.817,436.931,329.249L436.931,329.249z M417.67,328.403l-1.893-0.083 c0.758,0.332,1.524,0.569,2.27,0.675C417.922,328.801,417.797,328.604,417.67,328.403L417.67,328.403z M410.127,328.073 l-4.297-0.188c1.609,3.132,3.705,6.023,6.378,8.555C411.207,333.378,410.524,330.448,410.127,328.073L410.127,328.073z M355.629,325.694l-23.652-1.033c-6.252,3.651-14.396,7.476-17.169,8.539c1.038,1.251,6.425,1.851,8.108,2.139	c-0.404,0.363-0.986,0.756-1.699,1.164l24.848,1.086c2.706-1.987,5.341-4.051,7.894-6.186c-0.753,2.134-1.761,4.281-2.948,6.401
		l17.22,0.752c-3.2-3.079-6.313-6.282-9.347-9.62C357.832,327.78,356.746,326.703,355.629,325.694L355.629,325.694z"
    />
    {/*Bee Red*/}
    <path 
        fill="rgb(225,0,0)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M406.69,368.433l47.303,8.854l-49.364,2.853L406.69,368.433 L406.69,368.433z M426.648,295.975c1.461,0.462,2.99,0.62,4.519,0.717c2.525,0.16,5.051-1.098,5.934-3.465	c0.662-1.774,0.477-3.723,0.439-5.616c-0.191-10-3.319-19.773-9.575-27.582c-2.594-3.233-6.071-5.704-10.019-6.959
		c-4.171-1.325-8.636-0.302-12.354,2.002c-2.909,1.8-5.448,4.3-6.375,7.594c-1.201,4.26-0.241,8.813,2.112,12.563 c3.394,5.407,7.626,10.253,12.675,14.16C417.79,292.318,422.082,294.531,426.648,295.975L426.648,295.975z M428.745,293.955 c-11.903-8.197-22.83-21.012-22.111-36.259c-7.204,3.146-6.257,11.891-3.017,17.013 C408.461,282.366,418.596,292.623,428.745,293.955L428.745,293.955z"
    /> 
    {/*Bee White*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M429.521,267.172c-4.578-6.217-13.676-12.011-15.62-12.839	C421.014,254.742,427.255,260.572,429.521,267.172L429.521,267.172z M325.149,208.642c27.354,4.817,49.679,9.888,63.533,32.456 l1.966-0.377c-15.181-25.201-42.775-30.085-65.313-34.443c-0.511-0.849-1.326-1.8-2.438-2.023
		c-1.248-0.271-7.416-1.213-10.16-1.858c1.568,2.191,5.786,8.065,8.656,8.464C322.99,211.078,324.518,210.127,325.149,208.642 L325.149,208.642z M382.769,326.208c0.612,0.625,1.31,1.036,1.933,0.42c0.623-0.617,0.137-1.391-0.341-1.99 c-2.743-3.441-5.529-6.457-8.862-9.329c-0.176-0.151-0.452-0.393-0.643-0.27c-0.191,0.124-0.09,0.479,0.027,0.668 C377.081,319.274,380.033,323.415,382.769,326.208L382.769,326.208z M390.899,317.155c0.589,0.575,1.253,0.947,1.826,0.355 c0.573-0.593,0.101-1.311-0.361-1.864c-2.649-3.181-5.331-5.959-8.524-8.592c-0.168-0.139-0.433-0.36-0.61-0.24 c-0.177,0.12-0.073,0.452,0.04,0.628C385.41,310.751,388.271,314.585,390.899,317.155L390.899,317.155z M373.943,333.59 c0.612,0.625,1.31,1.036,1.933,0.42c0.624-0.617,0.138-1.391-0.341-1.99c-2.742-3.441-5.529-6.457-8.862-9.329 c-0.176-0.151-0.452-0.394-0.643-0.27c-0.191,0.123-0.09,0.479,0.027,0.668C368.256,326.655,371.208,330.797,373.943,333.59 L373.943,333.59z M196.668,197.455l-3.989,4.658l-45.058-10.984l6.45,11.953l31.226,7.613l-4.128,4.799l-23.49-5.727l6.341,11.75 l9.892,2.412l-4.254,4.945l-1.921-0.469l1.665,3.087c1.672,2.95,3.418,5.774,5.252,8.463l64.035,15.612l3.535,6.803l-62.098-15.14	c9.732,11.681,21.881,19.931,38.211,23.458c22.395,3.729,50.537-1.821,71.588-15.877c19.701-13.154,32.52-12.629,49.791-7.42 c-6.004-13.828-15.793-27.776-31.17-31.525l-87.721-21.387l-50.982-3.564L196.668,197.455L196.668,197.455z"
    />
    {/*Wing One*/}
    <path 
        fill="rgb(210,210,210)" 
        d="M270.748,206.652l37.799,9.215 c10.367,2.528,18.193,9.691,24.033,18.328l-79.33-4.852c-18.387-1.125-5.965,30.828-22.414,18.791
		c-13.847-10.339-30.924-16.596-49.456-16.92c-3.994-0.069-7.929,0.141-11.788,0.607c-0.063-0.109-0.127-0.219-0.189-0.329 l-1.665-3.087l1.921,0.469l4.254-4.945l-9.892-2.412l-6.341-11.75l23.49,5.727l4.128-4.799l-24.503-5.975L270.748,206.652	L270.748,206.652z"
    />
    {/*Door Handle*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M302.899,232.38c-0.903-1.849-2.974-4.587-8.14-6.69 c-9.912-4.039-26.723-4.895-28.843-5.051c-2.937-0.219-9.122-0.149-8.186,5.914l0.478,3.094L302.899,232.38L302.899,232.38z"
    />
    {/*Door Handle Shadow*/}
    <path 
        fill="rgb(130,130,130)" 
        d="M266.162,231.082c1.954,0,3.548,1.594,3.548,3.548	s-1.594,3.548-3.548,3.548c-1.953,0-3.547-1.594-3.547-3.548S264.209,231.082,266.162,231.082L266.162,231.082z M300.152,232.212 l-29.457-1.802c0.471,5.016,2.687,6.109,4.926,6.132l20.105,1.186C300.893,237.779,300.152,232.212,300.152,232.212 L300.152,232.212z"
    />
    {/*B&H*/}
    <path 
        fill="rgb(0,0,0)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M282.172,218.303l-13.891-3.387l-27.023,31.415l13.891,3.388l11.51-13.382 l10.604,2.585l-11.51,13.381l14.359,3.501l27.024-31.415l-14.36-3.502l-11.385,13.236l-10.604-2.586L282.172,218.303	L282.172,218.303z M196.443,235.405c6.686,1.631,20.807,0.126,23.152-7.988c0.797-2.774-1.752-5.54-4.029-6.903l-0.074-0.328 c0.169-0.22,0.426-0.365,0.704-0.364c4.729,0.003,12.354-2.235,13.544-7.622c1.274-5.783-6.771-8.332-10.929-9.345l-19.198-4.681 L172.59,229.59L196.443,235.405L196.443,235.405z M240.94,227.419c-0.157-1.08-0.272-2.144-0.478-3.274 c-0.547-3.748,4.652-1.403,5.711-0.464l2.143-1.882c-3.466-3.453-13.625-5.391-13.945,1.758c-2.752-0.018-7.997,0.857-8.682,4.168	c-1.214,5.837,8.223,5.934,11.744,5.749c0.471,0.78,1.264,1.522,2.148,1.738l3.895,0.95c0.309,0.074,0.668-0.043,0.943-0.203 l0.609-2.502l-2.238-0.549c-1.232-0.302-0.298-1.031,0.154-1.195c1.71-0.617,3.289-1.518,4.66-2.713l1.68,0.409l1.848-2.148 l-7.072-1.724c-0.852,0.748-1.416,1.243-2.083,1.857l1.026,0.864C242.164,228.781,241.119,228.643,240.94,227.419L240.94,227.419z M201.355,228.253c2.211-0.712,4.085-2.399,4.745-4.618c0.38-1.279-0.776-2.251-2.194-2.598l-5.796-1.412l-7.257,8.436l1.969,0.48	C195.613,229.221,198.615,229.135,201.355,228.253L201.355,228.253z M211.516,214.206c1.633-0.765,2.889-2.161,3.549-3.837 c0.748-1.898-2.975-2.715-4.243-3.024l-1.775-0.433l-6.235,7.25l2.064,0.503C207.52,215.31,209.416,215.186,211.516,214.206
		L211.516,214.206z M235.516,230.461l-0.584-4.004c-1.268-0.072-2.561,0.642-2.875,1.871 C231.639,229.956,234.221,230.899,235.516,230.461L235.516,230.461z M262.471,217.369l2.752-3.199l-34.781-8.48 c1.099,1.235,1.863,2.721,2.06,4.373L262.471,217.369L262.471,217.369z M238.199,245.586l2.574-2.993l-26.238-6.397 c-2.125,0.973-4.384,1.598-6.684,1.992L238.199,245.586L238.199,245.586z"
    /> 
    {/*Door Handle H*/}
    <path 
        fill="rgb(65,65,65)" 
        d="M263.383,220.609l-5.569,6.475l0.396,2.563l13.495,0.826 l7.349-8.544c-6.418-0.911-11.977-1.204-13.136-1.29C265.211,220.586,264.319,220.55,263.383,220.609L263.383,220.609z M300.394,232.227l1.395-1.621c-1.235-1.594-3.344-3.416-7.028-4.916c-1.457-0.595-3.066-1.119-4.754-1.584l-6.117,7.111 L300.394,232.227L300.394,232.227z"
    />

    

		</svg>
		</div>

	);//return
}